import LinkedAccount from './LinkedAccount'

export default LinkedAccount
